import { useEffect } from 'react';
import Button from '@rio-cloud/rio-uikit/Button';

export const DETACHED_LOCAL_STORAGE_KEY = 'detached-html';

const DetachedPreview = () => {
    const html = localStorage.getItem(DETACHED_LOCAL_STORAGE_KEY);

    // That removes the content from localStorage after the first render, so it’s only available briefly and reduces risk
    useEffect(() => {
        localStorage.removeItem(DETACHED_LOCAL_STORAGE_KEY);
    }, []);

    // Construct the Slack URL
    const slackChannel = 'C8T2WSZJ9';
    const slackUser = 'T0FJQS8J1';
    const slackURL = `https://app.slack.com/client/${slackUser}/${slackChannel}/new-message`;

    const handleClickFigmaButton = () => {
        const figmaTemplateFileID = 'wo3QaivIbsFk1UYbHt54QM'; // Replace with your actual template file ID
        const figmaURL = `https://www.figma.com/file/${figmaTemplateFileID}`;
        window.open(figmaURL, '_blank');
    };

    return (
        <div className='height-100vh bg-white'>
            <div id='detached-content'>
                <div className='padding-x-10 bg-lightest border border-bottom-only display-flex align-items-center justify-content-between height-60'>
                    <Button id='open-figma' bsStyle='primary' onClick={handleClickFigmaButton}>
                        <span className='uikit-icon icon-question' />
                        How to use the UIKIT in Figma
                    </Button>
                    <a className='btn btn-muted' href={slackURL} target='_blank' rel='noopener'>
                        <span className='uikit-icon icon-damages' />
                        Report broken import of the current view
                    </a>
                </div>
                <div className='padding-15' dangerouslySetInnerHTML={{ __html: html || 'No content to show' }} />
            </div>
        </div>
    );
};

export default DetachedPreview;
